import { IBaseReport, ReportDictionary } from '../models/reports.internal';

export default function toReportDictionary<T extends { id: IBaseReport['id'] }>(reports: T[]): ReportDictionary<T> {
  const dict: ReportDictionary<T> = {};
  reports.forEach(r => dict[r.id] = r);

  return dict;
}